export class Profile {
  public name: string;
  public familyName: string;
  public fullName: string;
  public email: string;
  public photo: string;
  public roles: string[];
  public schoolId: string;
  public schoolName: string;
  public username: string;
  public myRoomId: string;
  public schoolRegion: string;
  public locale: string;
  public license: string;
  constructor(user: any) {
    this.fullName = user?.firstName + ' ' + user?.lastName;
    this.name = user?.firstName;
    this.familyName = user?.lastName;
    this.email = user?.email;
    this.photo = user?.picture;
    this.roles = user?.attributes.roles;
    this.schoolId = user?.attributes.schoolId;
    this.schoolName = user?.attributes.schoolName;
    this.username = user?.username;
    this.myRoomId = user?.attributes.coreId;
    this.schoolRegion = user?.attributes.schoolLanguage;
    this.locale = user?.attributes.language;
    this.license = user?.attributes.license;
  }
}
